"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeFromJson = void 0;
const either = __importStar(require("fp-ts/Either"));
const t = __importStar(require("io-ts"));
/**
 * Attempts to decode the raw JSON-formatted info according to the provided codec.
 *
 * @param raw Raw info that may or may not be a correctly JSON-formatted string.
 * @param codec A codec to interpret the deserialized JSON as.
 * @return The decoded info, or undefined if the decoding was unsuccessful.
 */
exports.decodeFromJson = (raw, codec) => {
    const decodedRaw = t.string.decode(raw);
    if (either.isLeft(decodedRaw)) {
        console.warn("Unable to parse transmission - not a string.");
        return;
    }
    let parsed;
    try {
        parsed = JSON.parse(decodedRaw.right);
    }
    catch (e) {
        console.warn("Unable to parse transmission - not valid JSON:", raw);
        return;
    }
    const decoded = codec.decode(parsed);
    if (either.isLeft(decoded)) {
        console.warn("Unable to parse transmission - invalid shape:", parsed);
        return;
    }
    return decoded.right;
};
//# sourceMappingURL=util.js.map